import React from "react"
import Card from "@mui/material/Card"
import Typography from "@mui/material/Typography"
import CardContent from "@mui/material/CardContent"
import AlertIcon from "mdi-material-ui/AlertDecagram"
import {useTranslation} from "next-i18next"
import {useSelector} from "../../store";
import NextLink from "next-translate-routes/link";
import {Box} from "@mui/material";
import {Image} from "mui-image"
import {styled} from "@mui/material/styles";
import {encodePayload} from "../../utils/payload";
import {RateMeImagePayload} from "../../../pages/api/rate-me-image";


const StyledImage = styled(Image)``


export const NeedsAcceptanceCard = () => {

    const {t, i18n} = useTranslation()

    const {firstName, username, photoHash, photoUrl} = useSelector((state) => state.userSession.currentProfile);

    const rateMeImagePayload = encodePayload<RateMeImagePayload>({
        lng: i18n.language || "en",
        photoUrl: photoUrl,
        photoHash: photoHash
    })


    return <Card square sx={{border: "1px solid #FF5D5D"}}>

        <CardContent sx={{
            p: {
                xs: 2,
                sm: 3
            }
        }}>

            <Typography gutterBottom variant='h4'>
                <AlertIcon style={{
                    marginBottom: 4,
                    marginRight: 4,
                    verticalAlign: "middle"
                }}/>{t("profile-acceptance-pending-title")}</Typography>
            <Typography variant='body1'>
                {t("profile-acceptance-pending")}
            </Typography>

            <Box sx={{display: "block", textAlign: "center"}}>
                <NextLink href={`/rate-me/${username}`}>
                    <StyledImage
                        sx={{
                            maxWidth: {
                                xs: "100%",
                                sm: "65%"
                            },
                            mt: 2,
                            border: "2px solid white",
                            "&:hover": {
                                border: "2px solid #149fbb",
                                cursor: "pointer"
                            },

                        }}
                        src={`/api/rate-me-image?payload=${rateMeImagePayload}`}
                    />
                </NextLink>
            </Box>
        </CardContent>
    </Card>

}
